export default __webpack_public_path__ + "static/logo-5060b7cba8f832792f2a835222fbe6c0.png";